// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"3187":"download.list","9690":"consultant.list"}[chunkId] || chunkId) + "." + {"3149":"da3e6e2a","3187":"f2863225","4271":"e1e26269","8474":"29035117","9690":"e1e26269"}[chunkId] + ".chunk.css";
};